<template>
  <div class="beta-wrap">
      <!-- <div class="beta-txt-wrap"> -->
          <p><span class="mr_5 txt-drk">Welcome to our new website!</span
            >New products, features & updates added daily. <span class="mob-nxt-ln">Email us<span
            class="ml_5"
            ><a class="txt-drk" href="mailto:feedback@shopeichlers.com">feedback@shopeichlers.com</a></span></span></p>
          
      <!-- </div> -->
      <!-- <img src="/img/beta_ex.svg" alt="close" class="beta-ex"
      @click="close()"> -->
  </div>
</template>

<script>
export default {
    methods:{
        close(){
            this.$emit('closeBeta')
        }
    }
}
</script>

<style scoped>
.beta-wrap{
    z-index: 99;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 39px;
    display: flex;
    align-items: center;
    /* color: #144834; */
    color: black;
    font-weight: 300;
    font-size: 16px;
    /* background: #E4E8E6; */
    background:#FFE7C6;
    justify-content: space-between;
    padding-left: 27px;
    padding-right: 27px;
}
.beta-wrap p{
    text-align: center;
    width: 100%;
}

.txt-drk{
    /* color: #144834; */
    color: black;
    font-weight: 500;
}
.beta-ex{
    height: 14px;
    width: 14px;
    margin-right: 14px;
    margin-left: 14px;
    cursor: pointer;
}
.mr_5{
    margin-right: 5px;
}
@media only screen and (max-width: 1170px){
    .beta-wrap{
        font-size: 14px;
    }
}
@media only screen and (max-width: 1040px){
    .beta-wrap{
        font-size: 13px;
    }
}
@media only screen and (max-width: 959px){
    .beta-wrap{
        font-size: 13px;
        line-height: 15px;
    }
}
@media only screen and (max-width: 768px){
    .beta-wrap{
        height: 43px;
        font-size: 11px;
    }
}
@media only screen and (max-width: 500px){
    .mob-nxt-ln{
        /* display: block; */
    }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/layouts/BetaHeader.vue